import { Partner } from "@/domain/entities/Partner";
import { IPartnerRepository } from "@/domain/repositories/IPartnerRepository";
import { IShowPartnerUseCase } from "@/domain/usecases/IShowPartnerUseCase";

export class ShowPartnerUseCase implements IShowPartnerUseCase {
    repository: IPartnerRepository
    constructor(repository: IPartnerRepository) {
        this.repository = repository
    }
    async execute(id: string): Promise<Partner> {
        const partner = await this.repository.show(id)
        const plan = await this.repository.listCodes(id)
        partner.plan = plan
        return partner
    }
}